import { createSelector } from '@reduxjs/toolkit';

import { IHeaderTitle } from '../../types/chatHeader';
import { selectChatHeader } from '../chatHeaderSelector';

const DEFAULT_HEADER_TITLE: IHeaderTitle = { primaryText: '' };

export const selectChatUserTitle = createSelector(selectChatHeader, header => header?.title || DEFAULT_HEADER_TITLE);
